import { RuleObject } from "antd/lib/form";
import { NamePath } from "antd/lib/form/interface";
import {
  KATAKANA_FULL_WIDTH,
  REGEX_EMAIL,
  REGEX_KATAKANA,
  REGEX_NUMBER,
  REGEX_PASSWORD,
  REGEX_ZIP_CODE,
} from "../constants/regex";
import { useTranslation } from "react-i18next";

type GetFieldValue = { getFieldValue: (name: NamePath) => any };

export const useRulesForm = () => {
  const { t } = useTranslation();

  const rulesForm = (nameField = "", message?: string) => ({
    required: {
      required: true,
      message: message || t("validate.isRequired", { field: nameField }),
    },
    min: (min: number) => ({
      min,
      message: message || t("validate.limitMinLength", { min }),
    }),
    max: (max: number) => ({
      max,
      message: message || t("validate.limitMinLength", { max }),
    }),
    email: {
      type: "email" as "array",
      message: message || t("validate.invalid", { field: nameField }),
      pattern: REGEX_EMAIL,
    },
    validatePassword: {
      pattern: REGEX_PASSWORD,
      message: message || t("validate.passwordInValidLongText"),
    },
    confirmPassword:
      (fieldPassword = "password") =>
      ({ getFieldValue }: GetFieldValue) => ({
        validator(rule: RuleObject, value: any) {
          if (getFieldValue(fieldPassword) !== value) {
            return Promise.reject(message || t("validate.matchPassword"));
          }
          return Promise.resolve();
        },
      }),
    katakana:
      () =>
      ({ getFieldValue }: GetFieldValue) => ({
        validator(rule: RuleObject, value: any) {
          if (!REGEX_NUMBER.test(value) && REGEX_KATAKANA.test(value)) {
            return Promise.resolve();
          }
          return Promise.reject(
            message || t("validate.invalid", { field: nameField })
          );
        },
      }),
    zipCode:
      () =>
      ({ getFieldValue }: GetFieldValue) => ({
        validator(rule: RuleObject, value: any) {
          if (REGEX_ZIP_CODE.test(value)) {
            return Promise.resolve();
          }
          return Promise.reject(
            message || t("validate.invalid", { field: nameField })
          );
        },
      }),
    // Kiểm tra chỉ được nhập full-width japan text: only katakana full width
    checkIsFullWidthText:
      (message?: string) =>
      ({ getFieldValue }: GetFieldValue) => ({
        validator(_rule: any, value: any) {
          const isKatakanaFullWidth = KATAKANA_FULL_WIDTH.test(value);

          if (!isKatakanaFullWidth) {
            return Promise.reject(
              message ||
                t("validate.onlyFullWidthKatakana", { field: nameField })
            );
          }

          return Promise.resolve();
        },
      }),
  });

  return { rulesForm };
};
